import { PlannedExpensesPage } from "@components/modules/projects/planned-expenses";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Planned expenses`} navigation={<NavigationProjects />}>
    <DemoModule module={Modules.Projects}>
      <PlannedExpensesPage />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/projects/planned-expenses")({
  component: Page,
});
